import React from 'react';
import Logs from 'components/Logs';
import PropTypes from 'prop-types';

const UserLogs = ({ id, title, ...params }) => {
  return <Logs title={title} targetType="User" targetId={parseInt(id)} {...params} />;
};

UserLogs.propTypes = {
  id: PropTypes.any.isRequired,
  title: PropTypes.string.isRequired,
};

export default UserLogs;
